import { useTheme } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { formatNumber } from './helpers';
import InnerDataOverviewCard from './InnerDataOverviewCard';
import { ColorMode } from 'src/components/app/types';
import { AggregateMetric } from 'src/pages/workflow-builder/aggregate-metrics/AggregateMetrics';

export const DataOverviewCard = ({
  color,
  colorMode = 'light',
  difference,
  isChild = false,
  label,
  size,
  tooltip,
  value,
}: AggregateMetric & {
  colorMode?: ColorMode;
  isChild?: boolean;
}) => {
  const { palette } = useTheme();

  const isParent = Array.isArray(value);

  function getDifferenceColor(difference: number) {
    if (difference === 0 || difference === undefined) {
      return colorMode === 'dark'
        ? 'rgba(255, 255, 255, 0.6)'
        : palette.colors.grey[600];
    }

    if (colorMode === 'dark') {
      return difference > 0 ? '#4ade80' : '#f87171'; // Lighter green/red for dark mode
    }

    return difference > 0 ? palette.colors.green[500] : palette.colors.red[500];
  }

  function formatDifference(label: string, value: number) {
    const formattedDifference = formatNumber(label, value);
    if (value === 0) {
      return formattedDifference;
    }
    const prefix = value > 0 ? '+' : '-';

    return prefix + formattedDifference;
  }

  return (
    <InnerDataOverviewCard
      appCuesTarget={`${label}LandingPageCard`}
      bottomRow={
        difference !== undefined && (
          <div data-testid='data-overview-card-difference'>
            <Typography
              color={getDifferenceColor(difference)}
              variant='font14Bold'
            >
              {formatDifference(label, difference)}
            </Typography>
          </div>
        )
      }
      cardLabel={label}
      cardValue={
        isParent ? (
          <>
            {value.map(v => (
              <DataOverviewCard
                key={v.label}
                {...v}
                colorMode={colorMode}
                isChild
              />
            ))}
          </>
        ) : (
          value
        )
      }
      colorMode={colorMode}
      isChild={isChild}
      isParent={isParent}
      labelColor={color}
      size={size}
      tooltipContent={tooltip}
    />
  );
};
